var Industry = "Branche";
var Aerospace = "Luft- und Raumfahrt";
var Agriculture = "Landwirtschaft";
var Automotive = "Automobilbranche";
var Education = "Bildungswesen";
var Gaming = "Computerspiele";
var Government = "Regierungen und Behörden";
var Healthcare = "Gesundheitswesen";
var Hospitality = "Hotel- und Gaststättengewerbe";
var Manufacturing = "Fertigung";
var Mining = "Bergbau";
var Other = "Sonstiges";
var Retail = "Einzelhandel";
var Telecommunications = "Telekommunikation";
var Travel = "Tourismus";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Computer und Elektronik",
	"Consumer goods": "Konsumgüter",
	Education: Education,
	"Financial services": "Finanzdienstleistungen",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Biowissenschaften",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing und Werbung",
	"Media & entertainment": "Medien und Unterhaltung",
	Mining: Mining,
	"Non-profit organization": "Gemeinnützige Organisationen",
	"Oil & gas": "Öl und Gas",
	Other: Other,
	"Power & utilities": "Energie und Versorgung",
	"Professional services": "Professionelle Dienstleistungen",
	"Real estate & construction": "Immobilien und Baugewerbe",
	Retail: Retail,
	"Software & internet": "Software und Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transport und Logistik",
	Travel: Travel,
	"Wholesale & distribution": "Großhandel und Vertrieb"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
